import { SvgIcon, type SvgIconProps } from './svgIcon'

type Props = SvgIconProps & {
  // strokeColor: string
}

export const AvatarIcon = ({ width = 24, height = 24, ...props }: Props) => (
  <SvgIcon width={width} height={height} viewBox="0 0 24 24" {...props}>
    <path
      d="M20.089 17.87C20.1491 17.79 20.2091 17.7 20.2691 17.62C21.3597 16.02 22 14.09 22 12C22 6.47 17.5278 2 11.995 2C6.46224 2 1.99001 6.47 2.00002 11.99C2.00002 14.25 2.74039 16.32 4.00102 18C4.06105 18.08 4.11107 18.15 4.1711 18.22C6.00201 20.52 8.68335 22 12.005 22C15.3267 22 18.2681 20.37 20.089 17.87ZM20.089 17.87C18.9785 14.56 15.997 12.18 12.1751 12.18C8.35319 12.18 5.15159 14.73 4.1611 18.22M15.3267 8.84C15.3267 10.6791 13.835 12.17 11.995 12.17C10.155 12.17 8.66334 10.6791 8.66334 8.84C8.66334 7.00089 10.155 5.51 11.995 5.51C13.835 5.51 15.3267 7.00089 15.3267 8.84Z"
      stroke="currentColor"
      strokeWidth="1.5"
      strokeMiterlimit="10"
    />
  </SvgIcon>
)
